export const environment = {
    production: true,
    testing: true,
    API_URL: 'https://totalcare-api-test.kenbri.nl/api/',
    API_TOKEN_URL: 'https://totalcare-api-test.kenbri.nl/connect/token',
    ApiTokenEndpoint: 'https://totalcare-api-test.kenbri.nl/connect/token',
    ApiMfaEndpoint: 'https://totalcare-api-test.kenbri.nl/connect/mfa',
    whitelistedDomains: ['totalcare-api-test.kenbri.nl'],
    blacklistedRoutes: ['https://totalcare-api-test.kenbri.nl/connect/token'],
    DEFAULT_TOKEN_NAME: 'id_token',
    DEFAULT_REFRESH_TOKEN_NAME: 'refresh_token',
    environmentName: 'test',
};

